import { LineNotify } from '../components/LineNotify'

/**
 * LINE通知ページ
 */
export function LineNotifyPage() {
  return <LineNotify />
}
